
import React, { useState, useEffect, useContext } from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';

export const PrimaryButton: React.FC<ButtonProps> = (options) => {
	return <Button variant="contained" color="primary" size="medium" fullWidth={true} {...options}></Button>
}

